// extracted by mini-css-extract-plugin
export default {"cls1":"ND8hkUxpVLKzh_Dm50QZ","cls2":"e6bUyn78ElN196c7VVhp ND8hkUxpVLKzh_Dm50QZ"};